import React from 'react';

const BenefitInfoWindow = (props) =>{

    const {img = '', title = '', text = '', distance = ''} = props;

    return(
        <div className='benefit-infoWindow'>
            <img src={img} alt={title}/>
            <div className='data-wrapper'>
                <span className='title'>{title}</span>
                <span className='text'>{text}</span>
            </div>
            <span className='distance'>{distance}</span>
        </div>
    );
};

export default BenefitInfoWindow;